import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';
import { rgba } from 'polished';

const ProfileStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  cursor: pointer;
  padding: 15px 5px;
  box-shadow: 0 -6px 16px 0 ${rgba(COLORS.black, 0.6)};
`;

export default ProfileStyled;
